// stores/useCallStore.js
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

/**
 * Call Store
 * Manages voice call and screen sharing state
 */
export const useCallStore = create(
  devtools(
    (set, get) => ({
      // ==================== State ====================
      isCallActive: false,
      isCallLockedByOtherTab: false,
      isMicOn: false,
      isScreenOn: false,
      isConnecting: false,
      isStartingScreen: false,
      callClient: null,
      callStatus: '',
      callTranscript: '',
      audioLevel: 0,

      callSavedConversationId: null,
      showContinueInChat: false,

      // ==================== Actions ====================
      setCallClient: client => set({ callClient: client }),
      // Call state
      setIsCallActive: active => set({ isCallActive: active }),

      setIsCallLockedByOtherTab: locked => set({ isCallLockedByOtherTab: locked }),

      setIsMicOn: on => set({ isMicOn: on }),

      setIsScreenOn: on => set({ isScreenOn: on }),

      setIsConnecting: connecting => set({ isConnecting: connecting }),

      setIsStartingScreen: starting => set({ isStartingScreen: starting }),

      // Call info
      setCallStatus: status => set({ callStatus: status }),

      setCallTranscript: transcript => set({ callTranscript: transcript }),

      appendToCallTranscript: text =>
        set(state => ({
          callTranscript:
            state.callTranscript + (state.callTranscript ? '\n' : '') + text,
        })),

      setAudioLevel: level => set({ audioLevel: level }),

      // Conversation continuation
      setCallSavedConversationId: id => set({ callSavedConversationId: id }),

      setShowContinueInChat: show => set({ showContinueInChat: show }),

      // Reset operations
      resetCallState: () => {
        const currentClient = get().callClient
        if (currentClient) {
          try {
            console.log('🔌 Disconnecting client from store reset...')
            currentClient.disconnect()
          } catch (e) {
            console.error('Error disconnecting client:', e)
          }
        }

        set({
          callClient: null, // Clear the reference
          isCallActive: false,
          isMicOn: false,
          isScreenOn: false,
          isConnecting: false,
          isStartingScreen: false,
          callStatus: '',
          callTranscript: '',
          audioLevel: 0,
          callSavedConversationId: null,
          showContinueInChat: false,
        })
      },

      resetCallForNewSession: () =>
        set({
          callStatus: '',
          callTranscript: '',
          audioLevel: 0,
          showContinueInChat: false,
          callSavedConversationId: null,
        }),
    }),
    { name: 'CallStore' }
  )
)
